"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Class = void 0;
/** Class names of DOM elements */
exports.Class = {
  MainDiv: 'heatmap-main-div',
  CanvasDiv: 'heatmap-canvas-div',
  Canvas: 'heatmap-canvas',
  Svg: 'heatmap-svg',
  Marker: 'heatmap-marker',
  MarkerX: 'heatmap-marker-x',
  MarkerY: 'heatmap-marker-y',
  TooltipBox: 'heatmap-tooltip-box',
  TooltipContent: 'heatmap-tooltip-content',
  PinnedTooltipBox: 'heatmap-pinned-tooltip-box',
  PinnedTooltipContent: 'heatmap-pinned-tooltip-content',
  PinnedTooltipPin: 'heatmap-pinned-tooltip-pin',
  PinnedTooltipClose: 'heatmap-pinned-tooltip-close',
  Overlay: 'heatmap-overlay',
  OverlayShade: 'heatmap-overlay-shade',
  OverlayMessage: 'heatmap-overlay-message',
  BrushClose: 'heatmap-brush-close'
};